import { ProviderEnum } from '@dynamic-labs/sdk-api';
import { isProviderEnabled } from '../isProviderEnabled/isProviderEnabled.js';

const isEmailProviderEnabled = (providers) => isProviderEnabled(providers, ProviderEnum.EmailOnly) ||
    isProviderEnabled(providers, ProviderEnum.Blocto) ||
    isProviderEnabled(providers, ProviderEnum.MagicLink);

export { isEmailProviderEnabled };
